export default function IconArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={props.width || 24}
      height={props.height || 24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        transform={
          props.rotate ? `rotate(${props.rotate}, 12, 12)` : ""
        }
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0598 4.99999L12.5295 5.53032L6.8098 11.25H18.9991H19.7491V12.75H18.9991H6.8098L12.5295 18.4697L13.0598 19L11.9991 20.0606L11.4688 19.5303L4.46881 12.5303L3.93848 12L4.46881 11.4697L11.4688 4.46966L11.9991 3.93933L13.0598 4.99999Z"
        fill="currentColor"
      />
    </svg>
  );
}
